<script setup lang="ts">

interface Props {
  isActive?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  isActive: false
})

const benefits = [
  {icon: 'core-clock-watch', text: 'Регистрируйтесь\nза одну минуту'},
  {icon: 'core-bookmark-favorite-search', text: 'Находите\nлучшие предложения'},
  {icon: 'core-document-bell', text: 'Размещайте\nпартнёрские офферы'},
]

</script>

<template>
  <div class="offer-exchange-benefits-desktop">
    <div
        v-for="(benefit, index) in benefits"
        :key="benefit.icon"
        class="offer-exchange-benefit"
        :class="{ active: isActive }"
        :style="{ '--index': index }">
      <ui-custom-icon :icon="benefit.icon" :size="44" color="primary"/>
      <span class="offer-exchange-benefit-text">{{ benefit.text }}</span>
    </div>
  </div>
  <div class="offer-exchange-benefits-mobile">
    <auth-layout-advertisement-benefits-mobile :benefits="benefits"/>
  </div>
</template>

<style scoped lang="scss">
@use 'assets/css/tokens/colors' as *;
@use 'assets/css/tokens/typography' as *;

.offer-exchange-benefits-desktop {
  display: flex;
  gap: clamp(1rem, 3.5vw, 3rem);

  @media (max-width: 959px) {
    display: none;
  }
}

.offer-exchange-benefit {
  display: flex;
  flex-direction: column;
  align-items: center;

  opacity: 0;
  transform: translateY(20px);

  &.active {
    animation: benefit-step var(--benefit-animation-duration, 400ms) ease forwards;
    animation-delay: calc(var(--index, 0) * var(--benefit-step-delay, 400ms));
  }
}

@keyframes benefit-step {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.offer-exchange-benefit-text {
  font-size: $font-size-12;
  line-height: $line-height-16;
  color: $color-dark-grey;
  white-space: pre-wrap;
  text-align: center;
  margin-top: 0.5rem;
}

.offer-exchange-benefits-mobile {
  display: flex;

  @media (min-width: 960px) {
    display: none;
  }
}

</style>